import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13c27eb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edu-courses-area pt-70 pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "single-courses-box" }
const _hoisted_5 = { class: "image" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "cr-tag" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "cr-price" }
const _hoisted_10 = { class: "cr-items" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bx-food-menu" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bx-time-five" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
          return (_openBlock(), _createElementBlock("div", {
            key: course.id,
            class: "col-lg-4 col-md-6 col-sm-6 d-flex"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: { name: 'CoursesDetailsPage', params: { id: course.id } },
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: course.image,
                      alt: course.title
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(course.category), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(course.price) + "₺", 1),
                _createElementVNode("h3", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'CoursesDetailsPage', params: { id: course.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(course.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createElementVNode("span", null, _toDisplayString(course.lessons) + " Ders", 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_12,
                    _createTextVNode(),
                    _createElementVNode("span", null, _toDisplayString(course.duration), 1)
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}